<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('menu.nei_musei').toUpperCase() }}
        </div>
      </div>
      <div class="area-description-container">
        <div class="area-description" v-html="pageDescription"></div>
      </div>

      <div class="home-subsection-div">
        <vueper-slides
            id="vueperslidesInMuseums"
            ref="vueperslidesInMuseums"
            class="no-shadow"
            :visible-slides="2"
            slide-multiple
            fixed-height="140px"
            arrows-outside
            bullets-outside
            :breakpoints="{ 1300: { visibleSlides: 1, fixedHeight: 140, arrows: false },
            1000: { visibleSlides: 1, fixedHeight: 220, arrows: false } }">
          <vueper-slide
              v-for="coll in inMuseums"
              :key="coll.id"
              style="display: flex; align-items: center;justify-content: center;"
              @click.native="setCurrentInMuseums(coll.id)">
            <template #content>
              <div class="maplinks-text-black" :id="'inmuseums-' + coll.id" :style="(currentInMuseumsId == coll.id ? 'text-decoration: underline;' : '')">{{ $utilities.getTranslation(coll, "titolo", $i18n.locale) }}</div>
            </template>

            <template #arrow-right>
              <i class="icon icon-arrow-right" />
            </template>
          </vueper-slide>
        </vueper-slides>
      </div>

      <div>
        <div class="mb-5">
          <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                  data-projection="EPSG:4326" ref="mapInMuseums" style="height: min(600px, 50vh)">

            <vl-view :min-zoom="5" :zoom.sync="inMuseumsZoom" :center.sync="inMuseumsCenter" ></vl-view>

            <vl-layer-tile id="osm" :overlay="true">
              <vl-source-osm></vl-source-osm>
            </vl-layer-tile>

            <vl-overlay
                class="map-overlay"
                v-for="coll in inMuseums"
                :key="coll.id"
                :position="[coll.luogo.longitudine, coll.luogo.latitudine]">
              <template>
                <div :class="currentInMuseumsId == coll.id? 'map-circle-on' : 'map-circle-off'" @click="openLocationInMuseums(coll.id)" style="cursor: pointer"></div>
              </template>
            </vl-overlay>

          </vl-map>
        </div>

        <div id="map-infos-container" class="mb-5" v-if="currentInMuseumsId != null">
          <div style="font-size: 20px;line-height: 40px;font-weight: 700;letter-spacing: 0.1em;text-transform: capitalize;">{{ translatedInMuseumsTitle }}</div>
          <div style="font-size: 20px;line-height: 126%;" v-html="translatedInMuseumsText"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'InMuseums',
  components: {VueperSlides, VueperSlide},
  data: function() {
    return {
      pageDescriptionRecord: "",
      inMuseumsCenter: [10,45],
      inMuseumsZoom: 8,
      inMuseums: null,
      currentInMuseumsId: null,
      loading: "(" + this.$t("caricamento") + "...)",
    };
  },
  created() {
    this.fetchTexts();
    this.fetchInMuseums();
  },
  computed: {
    pageDescription() {
      return this.$utilities.getTranslation(this.pageDescriptionRecord, "contenuto", this.$i18n.locale);
    },
    translatedInMuseumsTitle() {
      for (let coll in this.inMuseums)
        if (this.inMuseums[coll].id == this.currentInMuseumsId)
          return this.$utilities.getTranslation(this.inMuseums[coll], "titolo", this.$i18n.locale);
      return "";
    },
    translatedInMuseumsText() {
      for (let coll in this.inMuseums)
        if (this.inMuseums[coll].id == this.currentInMuseumsId)
          return this.$utilities.getTranslation(this.inMuseums[coll], "descrizione", this.$i18n.locale);
      return "";
    },
  },
  methods: {
    // Recupera le collezioni di scavi archeologici
    async fetchTexts() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'nei_musei'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];
    },
    async fetchInMuseums() {
      const inMuseumsData = await this.$client.getItems("nei_musei", {fields: ["*", "traduzioni.*"], filter: {
          luogo: {
            neq: null
          }
        }
      });
      let inMuseums = inMuseumsData.data;
      let placesIds = "";
      for (let i in inMuseums) {
        placesIds += inMuseums[i].luogo.id + ",";
      }

      const places = await this.$client.getItems("luoghi", {
        fields: ["id", "longitudine", "latitudine"], limit: -1, filter: { id: { in: placesIds } }
      });
      let placesData = places.data;
      for (let coll in inMuseums) {
        if (inMuseums[coll].luogo != null) {
          for (let i in placesData) {
            if (placesData[i].id == inMuseums[coll].luogo.id) {
              inMuseums[coll].luogo.longitudine = placesData[i].longitudine;
              inMuseums[coll].luogo.latitudine = placesData[i].latitudine;
            }
          }
        }
      }

      this.inMuseums = inMuseums.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
    },
    setCurrentInMuseums(id) {
      this.currentInMuseumsId = id;
      for (let coll in this.inMuseums)
        if (this.inMuseums[coll].id == id)
          this.$refs.mapInMuseums.$map.getView().fit(this.$refs.mapInMuseums.pointToViewProj(
              [this.inMuseums[coll].luogo.longitudine - 0.1, this.inMuseums[coll].luogo.latitudine - 0.1]).concat(this.$refs.mapInMuseums.pointToViewProj(
              [this.inMuseums[coll].luogo.longitudine + 0.1, this.inMuseums[coll].luogo.latitudine + 0.1])));
    },
    getPlaceTranslation(place) {
      return this.$utilities.getTranslation(place, "denominazione", this.$i18n.locale);
    },
    openLocationInMuseums(id) {
      document.getElementById("inmuseums-" + id).click();
    },
  }
}
</script>

<style>
</style>
